import * as DialogPrimitive from '@radix-ui/react-dialog'
import { keyframes, styled } from 'ui'

const overlayShow = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 }
})

const overlayHide = keyframes({
  from: {
    opacity: 1
  },
  to: {
    opacity: 0
  }
})

const contentShow = keyframes({
  '0%': { opacity: 0, transform: 'translate(-50%, -48%) scale(.96)' },
  '100%': { opacity: 1, transform: 'translate(-50%, -50%) scale(1)' }
})

const contentHide = keyframes({
  '0%': { opacity: 1, transform: 'translate(-50%, -50%) scale(1)' },
  '100%': { opacity: 0, transform: 'translate(-50%, -48%) scale(.96)' }
})

export const StyledOverlay = styled(DialogPrimitive.Overlay, {
  zIndex: 10,
  backgroundColor: 'rgba(0,0,0,0.75)',
  position: 'fixed',
  inset: 0,

  '&[data-state="closed"]': {
    animation: `${overlayHide} 150ms cubic-bezier(0.16, 1, 0.3, 1)`
  },

  '@media (prefers-reduced-motion: no-preference)': {
    animation: `${overlayShow} 150ms cubic-bezier(0.16, 1, 0.3, 1)`
  }
})

export const StyledContent = styled(DialogPrimitive.Content, {
  zIndex: 11,
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90vw',
  minWidth: '200px',
  maxHeight: '95vh',

  px: '$5',
  pt: '$10',
  pb: '$5',

  bgc: '$bg1',
  border: '1px solid $bg3',
  borderRadius: '$md',

  boxShadow: '$md',

  '&:focus': { outline: 'none' },

  '@media (prefers-reduced-motion: no-preference)': {
    '&[data-state="closed"]': {
      animation: `${contentHide} 250ms cubic-bezier(0.16, 1, 0.3, 1)`
    },

    animation: `${contentShow} 500ms cubic-bezier(0.16, 1, 0.3, 1)`
  },

  variants: {
    size: {
      sm: {
        maxWidth: '450px'
      },
      md: {
        maxWidth: '632px'
      },
      lg: {
        maxWidth: '1000px'
      }
    }
  },

  defaultVariants: {
    size: 'md'
  }
})

export const StyledTitle = styled(DialogPrimitive.Title, {
  fontWeight: '$semi-bold',
  color: '$text1',
  fontSize: '$2xl',
  lineHeight: '$xl',
  textAlign: 'center'
})

export const StyledDescription = styled(DialogPrimitive.Description, {
  color: '$text2',
  fontSize: '$sm',
  lineHeight: '$sm'
})

export const StyledClose = styled(DialogPrimitive.Close, {
  position: 'absolute',
  top: '$2-5',
  right: '$2-5',
  color: '$text2',

  '&:hover': {
    color: '$text1'
  },

  '@md': {
    top: '$4',
    right: '$4'
  }
})
